import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames/bind';
import { useStore } from '@thd-nucleus/experience-context';
import { Button } from '@thd-olt-component-react/button';
import { Col, Row } from '@thd-olt-component-react/grid';
import {
  params,
  alias,
  shape as shapeType,
  string as stringType,
  bool as boolType,
} from '@thd-nucleus/data-sources';
import { useDataModel } from '@thd-nucleus/data-sources/react/dataModel/useDataModel';
import { doorTypeURLs } from './door-types';

import styles from './online-door.module.scss';

let cx = classNames.bind(styles);

const getConsultationType = (data) => data?.product?.info?.consultationType;
const isVirtualConsultingAvailable = (data) => data?.serviceAddOns?.consultationDetails?.virtualAssistanceFlag;

export const OnlineDoor = ({ itemId }) => {

  const { storeId } = useStore();

  const { data, loading } = useDataModel('clientOnlyProduct', {
    variables: { itemId },
    ssr: false,
    skip: storeId === '8119'
  });

  const { data: serviceAddOnsData, loading: sLoading } = useDataModel('serviceAddOns', {
    variables: { itemId, storeId },
    ssr: false,
    skip: storeId === '8119'
  });

  if (loading || sLoading || !data || !serviceAddOnsData) {
    return null;
  }

  const buttonURL = doorTypeURLs[getConsultationType(data)];

  if (!(buttonURL && isVirtualConsultingAvailable(serviceAddOnsData))) {
    return null;
  }

  const contactDetails = {
    contactNumber: '18334327766',
    contactLabel: '1-833-432-7766'
  };

  return (
    <div className={cx('online-door')}>
      <Col nopadding fallback={12} sm={7} className={cx('online-door__banner-container')}>
        <div className={cx('online-door__man')}>
          <img
            width={260}
            height={224}
            src="http://assets.homedepot-static.com/images/v1/mvaman.png"
            alt="mva man icon"
          />
        </div>
        <div className={cx('online-door__banner-info')}>
          <div className={cx('online-door__banner-text')}>
            <div className={cx('online-door__banner-text-main')}>
              <span>Speak to an</span>
              <span className={cx('online-door__banner-text--large')}>EXPERT</span>
              <span>about Doors &amp; Windows</span>
            </div>
            <div className={cx('online-door__banner-text--desktop')}>
              <span>Complimentary Design</span>
              <span>Purchase and installation Options</span>
            </div>
          </div>
        </div>
      </Col>
      <Col nopadding fallback={12} sm={5} className={cx('online-door__info-container')}>
        <div className={cx('online-door__info-content')}>
          <div className={cx('online-door__info')}>
            <div>
              <img
                width={39}
                height={69}
                className={cx('online-door__icon')}
                src="https://assets.homedepot-static.com/images/v1/MVAPhone.svg"
                alt="mobile icon"
              />
            </div>
            <div className={cx('online-door__info-text')}>

              <div className={cx('online-door__header')}>
                Have More Questions?
              </div>
              <div>
                Speak to a Door and Window expert.
                <br />
                Available daily from 9&nbsp;am - 8&nbsp;pm EST.
              </div>
            </div>
          </div>
          <Button
            outline
            dark
            tag="a"
            href={buttonURL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Get Started
          </Button>
          <p className={cx('online-door__phone-text')}>
            Or call
            <a
              className={cx('u__default-link', 'online-door__phone-number')}
              href={`tel:${contactDetails.contactNumber}`}
            >
              {contactDetails.contactLabel}
            </a>
          </p>
        </div>
      </Col>
    </div>
  );
};

OnlineDoor.propTypes = {
  itemId: string.isRequired
};

OnlineDoor.dataModel = {
  clientOnlyProduct: alias('product').params({ itemId: stringType().isRequired() }).shape({
    itemId: stringType(),
    dataSources: stringType(),
    info: shapeType({
      consultationType: stringType()
    })
  }),
  serviceAddOns: params({ itemId: stringType().isRequired(), storeId: stringType().isRequired() }).shape({
    consultationDetails: shapeType({
      virtualAssistanceFlag: boolType()
    })
  })
};
